import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './QuillJournal.css';

const QuillJournal = ({ onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      className="quill-journal"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      title="Open Journal"
    >
      <svg
        className="quill-svg"
        viewBox="0 0 250 200"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Ink well */}
        <g className="ink-well">
          {/* Ink well base */}
          <ellipse
            cx="80"
            cy="160"
            rx="35"
            ry="15"
            fill="#2c1810"
            opacity="0.9"
          />
          {/* Ink well body */}
          <rect
            x="45"
            y="140"
            width="70"
            height="20"
            fill="#3d2817"
            rx="5"
          />
          {/* Glass reflection */}
          <ellipse
            cx="75"
            cy="145"
            rx="15"
            ry="8"
            fill="white"
            opacity="0.2"
          />
          {/* Ink inside */}
          <ellipse
            cx="80"
            cy="148"
            rx="25"
            ry="10"
            fill="#1a0f08"
          />
        </g>

        {/* Quill feather */}
        <g className="quill-feather">
          {/* Quill shaft */}
          <motion.path
            d="M 100,150 Q 120,100 140,50 T 150,10"
            stroke="#f5f5f5"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
            animate={isHovered ? { rotate: -10, x: 5 } : { rotate: 0, x: 0 }}
            transition={{ duration: 0.3 }}
            style={{ transformOrigin: '100px 150px' }}
          />

          {/* Feather vanes - left side */}
          <motion.path
            d="M 105,140 Q 90,130 85,120 T 80,100"
            stroke="#e8e8e8"
            strokeWidth="20"
            fill="none"
            strokeLinecap="round"
            opacity="0.6"
            animate={isHovered ? { rotate: -10, x: 5 } : { rotate: 0, x: 0 }}
            transition={{ duration: 0.3 }}
            style={{ transformOrigin: '100px 150px' }}
          />
          <motion.path
            d="M 115,100 Q 100,80 95,60 T 90,30"
            stroke="#e8e8e8"
            strokeWidth="25"
            fill="none"
            strokeLinecap="round"
            opacity="0.7"
            animate={isHovered ? { rotate: -10, x: 5 } : { rotate: 0, x: 0 }}
            transition={{ duration: 0.3 }}
            style={{ transformOrigin: '100px 150px' }}
          />

          {/* Feather vanes - right side */}
          <motion.path
            d="M 115,140 Q 130,130 135,120 T 145,100"
            stroke="#f5f5f5"
            strokeWidth="20"
            fill="none"
            strokeLinecap="round"
            opacity="0.6"
            animate={isHovered ? { rotate: -10, x: 5 } : { rotate: 0, x: 0 }}
            transition={{ duration: 0.3 }}
            style={{ transformOrigin: '100px 150px' }}
          />
          <motion.path
            d="M 125,100 Q 140,80 145,60 T 155,25"
            stroke="#f5f5f5"
            strokeWidth="25"
            fill="none"
            strokeLinecap="round"
            opacity="0.7"
            animate={isHovered ? { rotate: -10, x: 5 } : { rotate: 0, x: 0 }}
            transition={{ duration: 0.3 }}
            style={{ transformOrigin: '100px 150px' }}
          />

          {/* Quill tip (nib) */}
          <motion.path
            d="M 98,155 L 102,155 L 100,165 Z"
            fill="#3d2817"
            animate={isHovered ? { rotate: -10, x: 5 } : { rotate: 0, x: 0 }}
            transition={{ duration: 0.3 }}
            style={{ transformOrigin: '100px 150px' }}
          />
        </g>

        {/* Small open journal/paper */}
        <g className="journal-book">
          {/* Left page */}
          <rect
            x="150"
            y="130"
            width="45"
            height="60"
            fill="#f5e6d3"
            stroke="#a68a64"
            strokeWidth="1"
            rx="2"
          />
          {/* Right page */}
          <rect
            x="195"
            y="130"
            width="45"
            height="60"
            fill="#f5e6d3"
            stroke="#a68a64"
            strokeWidth="1"
            rx="2"
          />
          {/* Binding */}
          <rect
            x="193"
            y="130"
            width="4"
            height="60"
            fill="#6b5644"
          />
          {/* Lines on pages */}
          {[...Array(8)].map((_, i) => (
            <g key={i}>
              <line
                x1="155"
                y1={140 + i * 6}
                x2="190"
                y2={140 + i * 6}
                stroke="#a68a64"
                strokeWidth="0.5"
                opacity="0.3"
              />
              <line
                x1="200"
                y1={140 + i * 6}
                x2="235"
                y2={140 + i * 6}
                stroke="#a68a64"
                strokeWidth="0.5"
                opacity="0.3"
              />
            </g>
          ))}
        </g>

        {/* Ink droplet (animated) */}
        <motion.circle
          cx="100"
          cy="155"
          r="2"
          fill="#1a0f08"
          initial={{ opacity: 0 }}
          animate={isHovered ? { opacity: [0, 1, 0], y: [0, 5, 10] } : { opacity: 0 }}
          transition={{ duration: 1, repeat: isHovered ? Infinity : 0, repeatDelay: 0.5 }}
        />
      </svg>

    </motion.div>
  );
};

export default QuillJournal;
